import { render, staticRenderFns } from "./ResetPasswordModalController.vue?vue&type=template&id=9d91cf5c&"
import script from "./ResetPasswordModalController.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordModalController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports